import { render, staticRenderFns } from "./AncillaryReissueSearchLegBodyCardMain.vue?vue&type=template&id=9db26588&scoped=true"
import script from "./AncillaryReissueSearchLegBodyCardMain.vue?vue&type=script&lang=js"
export * from "./AncillaryReissueSearchLegBodyCardMain.vue?vue&type=script&lang=js"
import style0 from "./AncillaryReissueSearchLegBodyCardMain.vue?vue&type=style&index=0&id=9db26588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db26588",
  null
  
)

export default component.exports